import { render } from "./PhotoCarousel.vue?vue&type=template&id=67d38c6b"
import script from "./PhotoCarousel.vue?vue&type=script&lang=ts"
export * from "./PhotoCarousel.vue?vue&type=script&lang=ts"
script.render = render

export default script